import * as net from '../net';

const ShippingDAO = {};

ShippingDAO.get_freight_quotes = (data) =>
  net.post({url: '/api/shipping/freight-quotes', data})

export default ShippingDAO;
